module.exports = __webpack_public_path__ + "static/img/icon_zylx01.a237900a.png";